import { openEditContact } from 'App/components/EditContact/openEditContact';

const createContact = (customerId, account) => {
	const OPTIONS = {
		customerId,
		account
	};

	return new Promise(resolve => {
		openEditContact(OPTIONS).then(contact => {
			return resolve(contact);
		});
	});
};

export default createContact;
